



































































import Vue from 'vue'
import { Component, Config } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import collect from 'collect.js'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import DepartmentSearch from '@/modules/department/components/shared/DepartmentSearch.vue'
import { TicketStoreRequestModel } from '@/modules/ticket/models/ticket-request.model'
import { TicketModelType } from '@/modules/ticket/models/ticket-resource.model'
import { StoreTicketUseCase } from '@/modules/ticket/use-cases/shared/store-ticket.use-case'
import { DepartmentIdModel } from '@/modules/department/models/department-resource.model'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

@Component({
  components: {
    DepartmentSearch,
    MediaUploader,
    BaseInput,
    Modal,
    BaseButton
  }
})
export default class NewTicketModal extends Vue {
  constructor(
    private readonly storeTicketUseCase: StoreTicketUseCase,
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  @PropSync('displayNewTicketModal') show!: boolean
  @Prop() itemId!: number | null
  @Prop() itemType!: TicketModelType | null

  userType: string = Config.get('userType')

  ticket: TicketStoreRequestModel = {
    department_id: 3,
    title: '',
    message: '',
    files: [],
    ticketable_type: this.itemType,
    ticketable_id: this.itemId
  }

  $refs!: {
    ticket: QForm
  }

  get defaultDepartment() {
    return [DepartmentIdModel.CONTENT_ITEM]
  }

  async send() {
    let ok = false
    ok = await this.$refs.ticket.validate()

    if (!ok) return

    this.storeTicketUseCase.execute(
      //@ts-ignore
      collect(this.ticket).filter().all()
    ).onSuccess(() => {
      this.show = false
    })
  }

  get showItemId() {
    if (this.itemId) {
      return `این تیکت مربوط به آیتم شماره:
      ${this.itemId}
      میباشد.`
    }
  }
}
